import { createContext, Dispatch } from "react";
import {
  FirmaFilterKeys,
  QueryFilter,
  QueryFilterEvent,
  FilterPreset,
  FilterPresetEvent,
  KursusFilterKeys,
  LinjeFilterKeys,
  PersonFilterKeys,
} from "../interfaces/filters";

export const FilterPresetsContext = createContext<FilterPreset[]>([]);
export const FilterPresetsEventContext = createContext<
  Dispatch<FilterPresetEvent>
>(() => {});

// person
export const PersonFiltersContext = createContext<
  QueryFilter<PersonFilterKeys>[]
>([]);

export const PersonFiltersEventContext = createContext<
  Dispatch<QueryFilterEvent<PersonFilterKeys>>
>(() => {});

// firma
export const FirmaFiltersContext = createContext<
  QueryFilter<FirmaFilterKeys>[]
>([]);

export const FirmaFiltersEventContext = createContext<
  Dispatch<QueryFilterEvent<FirmaFilterKeys>>
>(() => {});

// kursus
export const KursusFiltersContext = createContext<
  QueryFilter<KursusFilterKeys>[]
>([]);

export const KursusFiltersEventContext = createContext<
  Dispatch<QueryFilterEvent<KursusFilterKeys>>
>(() => {});

// linje
export const LinjeFiltersContext = createContext<
  QueryFilter<LinjeFilterKeys>[]
>([]);

export const LinjeFiltersEventContext = createContext<
  Dispatch<QueryFilterEvent<LinjeFilterKeys>>
>(() => {});
